import ApiService from "../core/services/api.service";

export default {
  getServices() {
    return ApiService.get(`admin/v1/services`);
  },
  addService(obj) {
    return ApiService.post(`admin/v1/services/create`, obj);
  },
  getService(serviceGuid) {
    return ApiService.get(`admin/v1/services/${serviceGuid}`);
  },
  editService(obj) {
    return ApiService.post(`admin/v1/services/edit`, obj);
  },
  addSubService(obj) {
    return ApiService.post(`admin/v1/services/subservices/create`, obj);
  },
  editSubService(obj) {
    return ApiService.post(`admin/v1/services/subservices/edit`, obj);
  },
 
};
